module.exports = __webpack_public_path__ + "img/2026-05_commencement.9958c4ae.webp";